'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const template = require('../templates/loading.ejs');
const PubSub = require('../PubSub');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-loading',
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.requestedRoute = options.route;
    },
    /**
     *
     */
    render: function () {
        this.$el.html(template(this.model));
        return this;
    },
    /**
     * 
     */
    renderedToDom: function() {
        this.waiting = setTimeout(function(){
            PubSub.trigger('directRoute', 'category', this.requestedRoute);
        }.bind(this), 1000);
    },
    /**
     * 
     */
    remove: function() {
        if(this.waiting) clearTimeout(this.waiting);
        return Backbone.View.prototype.remove.call(this);
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/loading.js